module.exports = __webpack_public_path__ + "img/avatar.9f7f3e55.svg";